export const useLocale = () => {
  const isArabic = localStorage.getItem('language') === 'ar';
  const isEnglish = !isArabic;
  const dir = isArabic ? 'rtl' : 'ltr';
  return { isArabic, isEnglish, dir };
};

export const useLocaleString = (ar: string, en: string) => {
  const { isArabic } = useLocale();
  const finalText = isArabic ? ar : en;
  if (!finalText || finalText.trim() === '') {
    return isArabic ? en : ar;
  }
  return finalText;
};
